import Modifier from 'ember-modifier';

import { set } from 'rise-ui/utils/object.js';

export default class PassPropertiesModifier extends Modifier {
  modify(element, [ key, value ], { object }) {
    if (object) {
      this.object = object;
    }
    if (!this.object) {
      return;
    }
    set(this.object, key, value);
  }
}
